import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from "rxjs";
import {EditorMmcModelService} from "@irb/irb-editors/editor-mmc-model/editor-mmc-model.service";
import {TooltipService} from "@irb-common/components/tooltip/tooltip.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {AppService} from "@irb/app.service";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IUserDetails} from "@irb/app.model";

@Component({ standalone: false,
  selector: 'irb-custom-overview-model',
  templateUrl: './custom-overview-model.component.html',
  styleUrl: './custom-overview-model.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CustomOverviewModelComponent implements OnInit, OnDestroy {

  @ViewChild('IrbDropdownAssetClass') IrbDropdownAssetClass: any;
  @ViewChild('IrbDropdownAllocChanges') IrbDropdownAllocChanges: any;
  @ViewChild('IrbDropdownRiskTolerance') IrbDropdownRiskTolerance: any;
  @ViewChild('asFirmIdBox') asFirmIdBox: any;
  @ViewChild('txtTurnover') txtTurnover: any;

  isTaxManaged: any;
  modelMarketName: string;
  assetClass: any;
  buildingBlockStyle: string;
  usedFor: string;
  allocationChangesSel: any;
  riskTolerance: any;
  isValid: boolean = true;
  modelNameTooltipMessage: string;
  allocationChanges: any;
  private assetClassOptions: any = [];
  private riskToleranceOptions: any = [];
  private allocationChangesList: any = [];
  private ddSub: Subscription;
  userDetails: any = {};
  turnover: number;
  advisorFirmId: any = null;
  isProcessing = false;
  isSociallyResponsible: any;

  @Input() data: any;
  @Output() change = new EventEmitter<boolean>();
  @Output() validChange = new EventEmitter<any>();
  @Input() eventModelType: string;

  constructor(private editorMmcModelService: EditorMmcModelService, private tts: TooltipService,
              private util: UtilityService,
              private as: AppService) {

    this.allocationChangesList = [
      {value: 'NONE', name: 'None'},
      {value: 'ANNUALLY', name: '+/- Annually'},
      {value: 'QUARTERLY', name: '+/- Quarterly'},
      {value: 'MONTHLY', name: '+/- Monthly'},
      {value: 'CONTINUOUS', name: 'Continuous/as needed'},
      {value: 'NEVER', name: 'Never'}
    ];

    this.getRoles(); //IREBAL-25075
    //this.usedFor = 'custom';
  }

  ngOnInit(): void {
    this.initValues();
    this.getDropDownsInfo();
    this.ddSub = this.editorMmcModelService.dropDownsDataLoaded.subscribe(() => {
      this.getDropDownsInfo()
    })
  }


  private initValues() {
    if (this.data && this.data.modelMarketName) {
      this.isProcessing = this.data.updateStatus === "PROCESSING";
      this.modelMarketName = this.data.modelMarketName;
      this.isTaxManaged = this.data.isTaxManaged;
      this.assetClass = this.data.assetClass ? {value: this.data.assetClass.id, name: this.data.assetClass.label} : null;
      this.buildingBlockStyle = this.data.buildingBlockStyle? this.data.buildingBlockStyle === 'Smart Beta' ? 'Smart Beta' : this.data.buildingBlockStyle.toLowerCase() : 'none';
      this.usedFor = this.data.usedFor.toLowerCase();
      this.allocationChanges = this.data.allocationChanges || 'NONE';
      if (this.data.allocationChanges)
        this.getAllocChangesByValue(this.data.allocationChanges);
      this.riskTolerance = this.data.riskTolerance ? {value: this.data.riskTolerance.id, name: this.data.riskTolerance.label} : null;
      this.turnover = this.data.turnover;
      this.isSociallyResponsible = this.data.isSociallyResponsible;
      this.advisorFirmId = this.data.advisorFirmId || null;
      this.validateEntries();
    } else {
      this.isValid = false;
      this.advisorFirmId = null;
      this.modelMarketName = '';
      this.usedFor = 'custom';
      this.isTaxManaged = false;
      this.buildingBlockStyle = 'none';
      this.allocationChanges = 'NONE';
      this.allocationChangesSel = {value: -1, name: 'None', label: 'NONE', id: -1};
      this.turnover = null;
      this.isSociallyResponsible = -1;
    }
  }

  private getAllocChangesByValue(val: string) {
    const o: any = this.allocationChangesList.filter((a: any) => {
      return a.value === val;
    });
    if (o && o.length !== 0) {
      this.allocationChangesSel = o[0];
    }
  }

  private getDropDownsInfo() {
    const dd: any = this.editorMmcModelService.getDropDownItems();
    if (dd) {
      const sortByKey = this.util.sortByKey;
      this.assetClassOptions = this.convertToValueLabel(dd.ASSET_CLASS.items);
      const assetClassNone = dd.ASSET_CLASS.items.find((item: any) => item.label.toUpperCase() === 'NONE');
      this.assetClassOptions = sortByKey(this.assetClassOptions, "name", 'asc');
      if (assetClassNone) {
        this.assetClassOptions.unshift({value: assetClassNone.id, name: 'None', id: assetClassNone.id, label: assetClassNone.label});
        if (!this.assetClass)
          this.onAssetClassChange(this.assetClassOptions[0])
      }

      this.riskToleranceOptions = this.convertToValueLabel(dd.RISK_TOLERANCE.items);
      const riskToleranceNone = dd.RISK_TOLERANCE.items.find((item: any) => item.label.toUpperCase() === 'NONE');
      this.riskToleranceOptions = sortByKey(this.riskToleranceOptions, "name", 'asc');
      if (riskToleranceNone) {
        this.riskToleranceOptions.unshift({value: riskToleranceNone.id, name: 'None', id: riskToleranceNone.id, label: riskToleranceNone.label});
        if (!this.riskTolerance)
          this.onRiskCategoryChange(this.riskToleranceOptions[0]);
      }
    }
  }

  getAssetClasses(searchStr: any) {
    this.IrbDropdownAssetClass.set(DropdownFilterComponent.getFilteredList(searchStr, this.assetClassOptions));
  }

  getAllocChanges(searchStr: string) {
    this.IrbDropdownAllocChanges.set(DropdownFilterComponent.getFilteredList(searchStr, this.allocationChangesList));
  }

  getRiskTolerances(searchStr: string) {
    this.IrbDropdownRiskTolerance.set(DropdownFilterComponent.getFilteredList(searchStr, this.riskToleranceOptions));
  }

  private convertToValueLabel(items: Array<any>) {
    let newArray: Array<any> = [], newEl: any;
    items.forEach((item: any) => {
      item.label = item.label || '';
      if (item.label.toUpperCase() !== 'NONE') {
        newEl = {
          value: item.id,
          name: item.label
        };
        newArray.push(newEl);
      }
    });
    return newArray;
  }


  onAssetClassChange(newAsset: any) {
    if (this.data && this.eventModelType === 'editMmcModel' && this.data.assetType) {
      this.data.assetClass.id = newAsset.value;
      this.data.assetClass.label = newAsset.name;
      this.data.assetClass.isUpdated = true;
    } else {
      this.data.assetClass = {
        id: newAsset.value,
        label: newAsset.name,
        isNew: true,
        isUIdeleted: false
      }
    }
    this.assetClass = newAsset;

    this.validateEntries();
  }

  onAllocChngChange(newAllocCh: any) {
    this.allocationChanges = newAllocCh.value;
    this.validateEntries();
  }

  onRiskCategoryChange(newRiskTolerance: any) {
    if (this.data && this.eventModelType === 'editMmcModel' && this.data.riskTolerance) {
      this.data.riskTolerance.id = newRiskTolerance.value;
      this.data.riskTolerance.label = newRiskTolerance.name;
      this.data.riskTolerance.isUpdated = true;
    } else {
      this.data.riskTolerance = {
        id: newRiskTolerance.value,
        label: newRiskTolerance.name,
        isNew: true,
        isUIdeleted: false
      }
    }
    this.riskTolerance = newRiskTolerance;
    this.validateEntries();
  }


  validateModelName() {
    setTimeout(() => {
      if (this.modelMarketName.length === 100) {
        this.modelNameTooltipMessage = 'Max character limit is 100';
      } else {
        this.modelNameTooltipMessage = '';
        this.tts.remove();
        this.validateEntries();
      }
    });
  }

  onAsFirmIdInput() {
    if (!this.asFirmIdBox.inputControl.valid) {
      this.validChange.emit({type: 'overview', valid: false});
      return;
    }
    this.validateEntries();
  }

  validateEntries() {
    if (this.advisorFirmId !== null) {
      if (this.advisorFirmId.toString().trim() === '') {
        this.advisorFirmId = null;
      }
    }
    this.isValid = this.modelMarketName.trim() === '' || !this.advisorFirmId
        ? false : true;

    this.updateDataValues();
    this.change.emit();
    this.validChange.emit({type: 'overview', valid: this.isValid});
  }

  private updateDataValues() {
    this.data.modelMarketName = this.modelMarketName;
    this.data.isTaxManaged = this.isTaxManaged;
    this.data.buildingBlockStyle = this.buildingBlockStyle;
    this.data.usedFor = this.usedFor;
    this.data.allocationChanges = this.allocationChanges;
    this.data.turnover = this.turnover ? this.turnover : null;
    this.data.isSociallyResponsible = this.isSociallyResponsible;
    this.data.advisorFirmId = this.advisorFirmId;
  }

  //IREBAL-25075
  private getRoles() {
    this.userDetails = this.as.getItem('IRB_APP_CONFIG') as IUserDetails || {};
  }

  onTurnoverInput() {
    if (this.txtTurnover && this.txtTurnover.inputControl) {
      if (!this.txtTurnover.inputControl.valid) {
        this.validChange.emit({type: 'overview', valid: false});
        return;
      }
      this.validateEntries();
    }
  }

  ngOnDestroy() {
    if (this.ddSub) {
      this.ddSub.unsubscribe();
    }
  }

}
